var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncConfigLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 17.2002C27.7 17.4002 26.8 17.2002 26.4 16.5002C26 15.8002 26.3 14.8002 27 14.0002C26.1 13.1002 25.1 12.5002 23.9 12.2002C23.6 13.2002 22.9 14.0002 22.1 14.0002C21.3 14.0002 20.6 13.3002 20.3 12.2002C19.1 12.5002 18 13.1002 17.2 14.0002C17.9 14.8002 18.2 15.8002 17.8 16.5002C17.4 17.2002 16.4 17.4002 15.4 17.2002C15.1 17.8002 15 18.4002 15 19.0002C15 19.6002 15.1 20.2002 15.2 20.8002C16.3 20.6002 17.2 20.8002 17.6 21.5002C18 22.2002 17.7 23.2002 17 24.0002C17.9 24.9002 18.9 25.5002 20.1 25.8002C20.4 24.8002 21.1 24.0002 21.9 24.0002C22.7 24.0002 23.4 24.7002 23.7 25.8002C24.9 25.5002 26 24.9002 26.8 24.0002C26.1 23.2002 25.8 22.2002 26.2 21.5002C26.6 20.8002 27.6 20.6002 28.6 20.8002C28.8 20.2002 28.8 19.6002 28.8 19.0002C28.8 18.4002 28.9 17.8002 28.8 17.2002Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21C23.1046 21 24 20.1046 24 19C24 17.8954 23.1046 17 22 17C20.8954 17 20 17.8954 20 19C20 20.1046 20.8954 21 22 21Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3V9H25L19 3ZM19 3H7V29H25V25.3",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 9V12",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncConfigLogoWhite);
export default __webpack_public_path__ + "static/media/inc-config-logo-white.b650609e9f9094eea6f5276266e1eeb2.svg";
export { ForwardRef as ReactComponent };